import React from 'react';
import { FullWidthNavigation } from '@johnlewispartnership/wtr-content-component-library';
import { type BannerLink } from 'types/adtech';
import { usePromoImpression } from 'hooks/use-promo-impression';
import { emptyLink } from 'utils/adtech/generate-banner-link';
import { TradingCellWrapperProps } from 'content/components/TradingCellWrapper';
import { EventType, sendAdTechEvent } from 'analytics/gtmServerFunctions';

export type FullWidthNavigationWrapperProps = Omit<TradingCellWrapperProps, 'textArea'> & {
  image: {
    landscapeImage: { src: string };
  };
  textArea?: {
    link?: Partial<BannerLink>;
  };
};

export const FullWidthNavigationWrapper = (props: FullWidthNavigationWrapperProps) => {
  const { componentId, analytics, position, products, isCitrusAd } = props;

  const observerRef = usePromoImpression({
    componentId,
    analytics,
    position,
    products,
  });

  const promoClickHandler = () => {
    if (isCitrusAd) {
      sendAdTechEvent({
        eventType: EventType.CLICK,
        sponsorshipId: componentId,
        trackingUrls: analytics?.clickUrls,
        vendor: analytics?.vendor,
      });
    }
  };

  const { textArea = { link: emptyLink } } = props;
  const { image } = props;
  const { landscapeImage } = image;
  return (
    <div ref={observerRef}>
      <FullWidthNavigation
        {...{
          ...props,
          textArea: {
            ...textArea,
            callToActionText: textArea.link?.text,
            callToActionAltText: textArea.link?.altText,
            callToActionURL: textArea.link?.url,
            newWindow: Boolean(textArea.link?.isExternalLink),
          },
        }}
        image={{ landscapeImage: { ...landscapeImage, dyanamicImages: { hiQuality85: {} } } }}
        onPromoClick={promoClickHandler}
      />
    </div>
  );
};
